"use client";

import { useIsDark } from "@/context/ThemeContext";
import { twMerge } from "tailwind-merge";

export default function MVPLayout({ children }) {
    const isdark = useIsDark();
  return (
    <div>
      {/* left top  */}
      <section className="relative -translate-y-70 xl:translate-y-0">
      <div className={twMerge("absolute top-[900px] left-[-63px] w-[313px] h-[272px] rounded-full rotate-126 blur-[100px]",  isdark ? "bg-[#8593E8] opacity-40" : "bg-[#A1ADF5] opacity-60")}/>
      <div className={twMerge("absolute top-[1100px] left-[-244px] w-[315px] h-[275px] rounded-full rotate-126 blur-[120px]", isdark ? "bg-[#5D6EF3] opacity-40" : "bg-[#2A40E7] opacity-40")}/>
      <div className={twMerge("absolute top-[1300px] left-[-260px] w-[300px] h-[262px] rounded-full rotate-126 blur-[100px]",isdark ? "bg-[#FC4FF6] opacity-20" : "bg-[#FF8DFB] opacity-60")}/>
      </section>

      <div className={twMerge("hidden md:block absolute top-[1093px] xl:top-[1393px] right-[-59px] w-[313px] h-[272px] rounded-full rotate-126 blur-[100px]",  isdark ? "bg-[#8593E8] opacity-40" : "bg-[#A1ADF5] opacity-60")}/>


      {/* left middle */}
      <section className="relative -translate-y-150 mobile:-translate-y-210 md:-translate-y-150 xl:translate-y-0">
      <div className={twMerge("absolute top-[2575px] left-[-112px] w-[300px] h-[262px] rounded-full rotate-126 blur-[100px]",isdark ? "bg-[#FC4FF6] opacity-20" : "bg-[#FF8DFB] opacity-60")}/>
      <div className={twMerge("absolute top-[2760px] left-[-159px] w-[313px] h-[272px] rounded-full rotate-126 blur-[120px]",  isdark ? "bg-[#8593E8] opacity-40" : "bg-[#A1ADF5] opacity-60")}/>
      <div className={twMerge("absolute top-[2941px] left-[-231px] w-[315px] h-[275px] rounded-full  rotate-126 blur-[100px]", isdark ? "bg-[#5D6EF3] opacity-40" : "bg-[#2A40E7] opacity-40")}/>
      </section>

        {/* right middle */}
      <section className="hidden md:block relative md:-translate-y-130 tablet:-translate-y-170 xl:translate-y-0">
        <div
          className={twMerge(
            "absolute top-[2400px] right-[-135px] w-[271px] h-[313px] rounded-full blur-[100px]",
            isdark ? "bg-[#8593E8] opacity-20" : "bg-[#A1ADF5] opacity-60"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[2652px] right-[-50px] w-[274px] h-[315px] rounded-full blur-[120px]",
            isdark ? "bg-[#5D6EF3] opacity-20" : "bg-[#2A40E7] opacity-40"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[2851px] right-[-154px] w-[262px] h-[300px] rounded-full blur-[100px]",
            isdark ? "bg-[#FC4FF6] opacity-20" : "bg-[#FF8DFB] opacity-60"
          )}
        />
      </section>

      <div className="">{children}</div>
    </div>
  );
};
